<div class="relative h-[95vh] -z-10">
  <div class="relative h-[164vh]">
    <div class="sticky top-0 w-full h-[95vh]">
      <div class="absolute w-full h-full">
        <div class="absolute bottom-24 lg:bottom-36 w-full text-white flex justify-center">
          <div class="w-full page-container">
            <div
              class="font-bold text-[4rem] sm:text[6rem] lg:text-[7rem] leading-[4rem] sm:leading-[5rem] lg:leading-[7rem] mb-2"
            >
              Unicup
            </div>
            <div class="text-blue-300 pl-1 text-lg sm:text-xl lg:text-2xl">
              Der Kampf um die Thyssenkrupp-Trophy in der 100,5-Arena
            </div>
          </div>
        </div>
      </div>

      <div class="absolute bg-black/45 w-full h-full -z-10"></div>
      <div class="absolute bg-platform opacity-40 w-full h-full -z-10"></div>
      <div class="relative h-full w-full">
        <div class="relative w-full h-full -z-20">
          <video
            [loop]="true"
            [muted]="true"
            [autoplay]="true"
            [controls]="false"
            playsinline
            class="h-full w-full object-cover"
            src="assets/unicup_hero.mp4"
          ></video>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="relative bg-white rounded-t-2xl -mt-8 text-platform flex justify-center py-16 lg:py-32">
  <div class="page-container">
    <div class="mb-6 lg:pb-10">
      <div class="font-bold text-5xl md:text-7xl lg:text-8xl">Herzlich Willkommen</div>
      <div class="text-xl md:text-2xl lg:text-4xl">zum Kartenvorverkauf des Unicup 2025!</div>
    </div>
    <div class="lg:text-xl font-light">
      <div class="font-bold mb-2">Allgemeine Infos:</div>
      <div class="leading-snug mb-4">
        Wie in jedem Jahr gibt es vier verschiedene Verkaufsstände: je einen der Fachschaften Medizin, Elektrotechnik
        und Maschinenbau, an denen nur Studierende der jeweiligen Fakultät Karten kaufen können. Eure
        Fakultätszugehörigkeit müsst ihr hier nachweisen können! Außerdem gibt es einen allgemeinen, freien Verkauf
        (HSZ-Stand). Hier dürfen alle Karten kaufen, völlig unabhängig vom Einschreibestatus.
      </div>

      @if (showExactDrawLocations.hasValue() && showExactDrawLocations.value().resourceValidDestructor) {
        <div class="mb-4">
          <div class="font-semibold mb-1">Die exakten Standorte der Verkaufsstände sind:</div>
          <ul>
            <li class="mb-1">
              <span class="font-semibold">Allgemeiner Verkauf (HSZ):</span> Physikzentrum (auf Seite der
              Produktionstechnik)
              <span class="underline"
                ><a
                  href="https://maps.app.goo.gl/iDLNRpymC1tY8G9G6"
                  target="_blank"
                  >(Maps-Link)</a
                ></span
              >
            </li>
            <li class="mb-1">
              <span class="font-semibold">Elektrotechnik:</span> 2. Sammelbau Biologie
              <span class="underline"
                ><a
                  href="https://maps.app.goo.gl/oN8ZDbfJziSo4HqU7"
                  target="_blank"
                  >(Maps-Link)</a
                ></span
              >
            </li>
            <li class="mb-1">
              <span class="font-semibold">Maschinenbau:</span> ELAB der Fachschaft Elektrotechnik
              <span class="underline"
                ><a
                  href="https://maps.app.goo.gl/2hUCsdWf4QFPRipm8"
                  target="_blank"
                  >(Maps-Link)</a
                ></span
              >
            </li>
            <li class="mb-1">
              <span class="font-semibold">Medizin:</span> Medizinisch Technisches Institut (MTI)
              <span class="underline"
                ><a
                  href="https://maps.app.goo.gl/rPwXFLYs5dPjcXkF6"
                  target="_blank"
                  >(Maps-Link)</a
                ></span
              >
            </li>
          </ul>
        </div>
      } @else {
        <div class="font-semibold mb-4">Alle Verkaufsstände werden sich im Bereich des Campus Melaten befinden.</div>
      }

      <div class="leading-snug mb-4">
        Um eine Karte ergattern zu können müsst ihr 2 Dinge tun: Erstens müsst ihr in Präsenz zum Verkaufsstand kommen
        und zweitens euch auf dieser Webseite für das Losverfahren anmelden.
      </div>

      @if (showExactDrawLocations.hasValue() && !showExactDrawLocations.value().resourceValidDestructor) {
        <div class="leading-snug mb-4">
          Die genauen Standorte der Stände werden euch zum Zeitpunkt der Schlangenöffnungen (00:01 Uhr) über Instagram
          und auf dieser Website mitgeteilt. Genauere Infos hierzu findest du unter dem Reiter Ablauf.
        </div>
      }

      <div class="leading-snug mb-8">
        Wir verlosen die Karten unter allen Personen, die sich nach der Bekanntgabe der Verkaufsorte innerhalb von 30
        Minuten an diesen einfinden. Es ist dabei nicht von Nöten, besonders schnell am Verkaufsstand zu sein. Ob ihr
        als Allererste*r oder Allerletzte*r in der Schlange seid, hat keinen Einfluss auf eure Chance, eine Karte zu
        bekommen.
      </div>

      <div class="font-semibold mb-1">Anmeldung in Gruppen:</div>
      <div class="leading-snug mb-8">
        Damit ihr nicht allein eine Karte gewinnt (und eure Freunde leer ausgehen) könnt ihr euch in Gruppen für die
        Losung anmelden. Ihr gewinnt dann entweder alle eine Karte oder keine(r) von euch. Registriert euch dafür ganz
        einfach nach Freischaltung am 3.12. auf dieser Webseite. In der Schlange am Morgen des 4.12. werdet ihr dann von
        uns abgescannt, um euer Los auf "gültig" zu setzen. Die gesamte Gruppe muss hierbei anwesend sein!
      </div>

      <div class="leading-snug mb-8">
        @if (selectedQueue() === undefined) {
          <div class="leading-snug mb-8">
            Um dir die genauen Regeln der Schlange deiner Wahl anzeigen zu können, wähle bitte aus:
          </div>

          <div class="grid xl:grid-cols-4 xl:gap-8 gap-3">
            <ticketing-button (click)="selectedQueue.set('eti')">Ich bin ein Eti</ticketing-button>
            <ticketing-button (click)="selectedQueue.set('maschi')">Ich bin ein Maschi</ticketing-button>
            <ticketing-button (click)="selectedQueue.set('medi')">Ich bin ein Medi</ticketing-button>
            <ticketing-button
              class="text-center"
              (click)="selectedQueue.set('hsz')"
              >Ich will zur HSZ&#8209;Schlange
            </ticketing-button>
            <!-- Bindestrich wird so enkodiert, damit der Browser keinen Zeilenumbruch an dieser Stelle machen kann-->
          </div>
        } @else if (selectedQueue() === 'eti') {
          <div class="mb-4">
            Ihr habt die Möglichkeit, euch alleine oder in Gruppen von bis zu 6 Personen anzumelden. Innerhalb eurer
            Gruppe könnt ihr pro Person bis zu zwei Karten erwerben.
          </div>
          <div class="mb-4">
            Beispiel:<br />Ihr bildet zu viert eine Gruppe und seid damit automatisch mit 4 Karten registriert. Darüber
            hinaus besteht die Möglichkeit, bis zu 4 weitere Karten in eure Registrierung als Extrakarten mit
            aufzunehmen (es gehen auch 3 Karten oder weniger).
          </div>
          <div class="mb-4">
            Bei einem Gewinn stehen euch eure persönlichen Karten sowie alle gewählten Extrakarten zu. Alle Karten
            müssen vollständig von euch erworben werden. Eure Gruppengröße und die Menge an Extrakarten beeinflussen
            nicht die individuelle Wahrscheinlichkeit, ob euer Los gewinnt.
          </div>
          <div class="flex flex-col sm:grid sm:grid-cols-2 place-content-center gap-2">
            <ticketing-button
              appearance="outline"
              (click)="selectedQueue.set(undefined)"
            >
              <div class="mx-4">Ich bin doch kein Eti</div>
            </ticketing-button>
            <ticketing-button
              appearance="primary"
              routerLink="/profile"
            >
              <div class="mx-4">Ab zur Losung!</div>
            </ticketing-button>
          </div>
        } @else if (selectedQueue() === 'maschi') {
          <div class="mb-4">
            Ihr habt die Möglichkeit, euch alleine oder in Gruppen von bis zu 6 Personen anzumelden. Innerhalb eurer
            Gruppe könnt ihr pro Person genau eine Karte erwerben. Wir möchten möglichst viele Menschen belohnen, die
            sich nachts auf den Weg nach Melaten machen. Bei uns gibt es im Gegensatz zu anderen Schlangen keine
            Extrakarten.
          </div>
          <div class="mb-4">
            Bei einem Gewinn stehen euch eure persönlichen Karten sowie alle gewählten Extrakarten zu. Alle Karten
            müssen vollständig von euch erworben werden. Eure Gruppengröße und die Menge an Extrakarten beeinflussen
            nicht die individuelle Wahrscheinlichkeit, ob euer Los gewinnt.
          </div>
          <div class="flex flex-col sm:grid sm:grid-cols-2 place-content-center gap-2">
            <ticketing-button
              appearance="outline"
              (click)="selectedQueue.set(undefined)"
            >
              <div class="mx-4">Ich bin doch kein Maschi</div>
            </ticketing-button>
            <ticketing-button
              appearance="primary"
              routerLink="/profile"
            >
              <div class="mx-4">Ab zur Losung!</div>
            </ticketing-button>
          </div>
        } @else if (selectedQueue() === 'medi') {
          <div class="mb-2">
            Ihr habt die Möglichkeit, euch alleine oder in Gruppen von bis zu 6 Personen anzumelden. Abhängig von der
            Größe eurer Gruppe könnt ihr Extrakarten wählen. Das Schema lautet wie folgt:
          </div>
          <ul class="list-disc list-inside mb-4">
            <li>ab 3 Personen: bis zu 1 Extrakarte</li>
            <li>ab 6 Personen: bis zu 2 Extrakarten</li>
          </ul>
          <div class="mb-4">
            Beispiel 1:<br />Ihr bildet zu zweit eine Gruppe und seid damit automatisch mit 2 Karten registriert. Bei
            dieser Gruppengröße habt ihr keine Möglichkeit, ein Extrakarte hinzuzufügen.
          </div>
          <div class="mb-4">
            Beispiel 2:<br />Ihr bildet zu viert eine Gruppe und seid damit automatisch mit 4 Karten registriert.
            Darüber hinaus besteht die Möglichkeit, bis zu einer weiteren Karte in eure Registrierung als Extrakarte mit
            aufzunehmen (ihr müsst aber nicht).
          </div>
          <div class="mb-4">
            Bei einem Gewinn stehen euch eure persönlichen Karten sowie alle gewählten Extrakarten zu. Alle Karten
            müssen vollständig von euch erworben werden. Eure Gruppengröße und die Menge an Extrakarten beeinflussen
            nicht die individuelle Wahrscheinlichkeit, ob euer Los gewinnt.
          </div>

          <div class="flex flex-col sm:grid sm:grid-cols-2 place-content-center gap-2">
            <ticketing-button
              appearance="outline"
              (click)="selectedQueue.set(undefined)"
            >
              <div class="mx-4">Ich bin doch kein Medi</div>
            </ticketing-button>
            <ticketing-button
              appearance="primary"
              routerLink="/profile"
            >
              <div class="mx-4">Ab zur Losung!</div>
            </ticketing-button>
          </div>
        } @else if (selectedQueue() === 'hsz') {
          <div class="mb-4">
            Ihr habt die Möglichkeit, euch alleine oder in Gruppen von bis zu 6 Personen anzumelden. Innerhalb eurer
            Gruppe könnt ihr pro Person genau eine Karte erwerben. Wir möchten möglichst viele Menschen belohnen, die
            sich nachts auf den Weg nach Melaten machen. Bei uns gibt es im Gegensatz zu anderen Schlangen keine
            Extrakarten.
          </div>
          <div class="mb-4">
            Bei einem Gewinn stehen euch eure persönlichen Karten sowie alle gewählten Extrakarten zu. Alle Karten
            müssen vollständig von euch erworben werden. Eure Gruppengröße und die Menge an Extrakarten beeinflussen
            nicht die individuelle Wahrscheinlichkeit, ob euer Los gewinnt.
          </div>
          <div class="flex flex-col sm:grid sm:grid-cols-2 place-content-center gap-2">
            <ticketing-button
              appearance="outline"
              (click)="selectedQueue.set(undefined)"
            >
              <div class="mx-4">Doch eine andere Schlange...</div>
            </ticketing-button>
            <ticketing-button
              appearance="primary"
              routerLink="/profile"
            >
              <div class="mx-4">Ab zur Losung!</div>
            </ticketing-button>
          </div>
        }
      </div>

      <div class="font-semibold mb-2">Warum nutzen wir so ein System?</div>
      <div class="mb-8">
        Der große Andrang an unseren Verkaufsständen hat in den vergangenen Jahren zu einigen gefährlichen Situationen
        geführt. Wir möchten verhindern, dass nicht mehr diejenigen eine Karte ergattern, die sich und andere am meisten
        gefährden oder am dreistesten vordrängeln. Alle, die sich mitten in der Nacht auf den Weg zum Kartenvorverkauf
        machen, sollen die gleiche Chance auf eine Karte haben.
      </div>

      <div class="mb-8">
        <span class="font-semibold"
          >Wir machen uns diesen ganzen Aufwand, damit am Ende alle von euch sicher nach Hause gehen. Bitte verzichtet
          daher auf jegliches Rennen, Autofahren, Rollerfahren, Fahrradfahren und auch auf Schlittschuhlaufen.</span
        >
      </div>
    </div>
  </div>
</div>
